import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import window from 'global/window';
import createSubscriptionAdapter from './subscribe-adapter';
import { addCallback, removeCallback, rootCallback } from './subscribe-callback';
import { SubscriptionAdapterStatus } from './types';
var REFRESH_TIMEOUT = 5000;
var setTimeoutSafe = window && typeof window.setTimeout === 'function' ? window.setTimeout : setTimeout;

var clearTimeoutSafe = function clearTimeoutSafe(timeout) {
  if (typeof timeout === 'number') {
    if (typeof window.clearTimeout === 'function') {
      window.clearTimeout(timeout);
    }
  } else {
    clearTimeout(timeout);
  }
};

var buildKey = function buildKey(viewModelName, aggregateIds) {
  var sortedAggregateIds = [].concat(aggregateIds).sort(function (a, b) {
    return a.localeCompare(b);
  });
  return [viewModelName].concat(sortedAggregateIds).join(':');
};

var adaptersMap = new Map();
var refreshTimeout;
export var getSubscriptionKeys = function getSubscriptionKeys(context, viewModelName, aggregateIds) {
  var viewModels = context.viewModels;
  var viewModel = viewModels.find(function (_ref) {
    var name = _ref.name;
    return name === viewModelName;
  });

  if (!viewModel) {
    return [];
  }

  var eventTypes = Object.keys(viewModel.projection).filter(function (eventType) {
    return eventType !== 'Init';
  });
  return eventTypes.reduce(function (acc, eventType) {
    if (Array.isArray(aggregateIds)) {
      acc.push.apply(acc, aggregateIds.map(function (aggregateId) {
        return {
          aggregateId: aggregateId,
          eventType: eventType
        };
      }));
    } else if (aggregateIds === '*') {
      acc.push({
        aggregateId: '*',
        eventType: eventType
      });
    }

    return acc;
  }, []);
};

var initSubscriptionAdapter = function initSubscriptionAdapter(url, cursor, context, viewModelName, aggregateIds) {
  var subscription = createSubscriptionAdapter({
    url: url,
    cursor: cursor,
    onEvent: rootCallback
  });
  subscription.init();

  if (!refreshTimeout) {
    refreshTimeout = setTimeoutSafe( // eslint-disable-next-line @typescript-eslint/no-use-before-define
    function () {
      return refreshSubscriptionAdapter(url, cursor, context, viewModelName, aggregateIds, false);
    }, REFRESH_TIMEOUT);
  }

  return subscription;
};

export var refreshSubscriptionAdapter = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, cursor, context, viewModelName, aggregateIds, subscriptionAdapterRecreated) {
    var subscriptionAdapter, key;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            key = buildKey(viewModelName, aggregateIds);
            _context.prev = 1;

            if (!adaptersMap.has(key)) {
              subscriptionAdapter = initSubscriptionAdapter(url, cursor, context, viewModelName, aggregateIds);
            } else {
              subscriptionAdapter = adaptersMap.get(key);
            }

            _context.next = 11;
            break;

          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](1);
            adaptersMap["delete"](key);

            if (refreshTimeout) {
              clearTimeoutSafe(refreshTimeout);
            }

            refreshTimeout = setTimeoutSafe(function () {
              return refreshSubscriptionAdapter(url, cursor, context, viewModelName, aggregateIds, true);
            }, REFRESH_TIMEOUT);
            return _context.abrupt("return", Promise.resolve());

          case 11:
            if (subscriptionAdapterRecreated) {
              _context.next = 21;
              break;
            }

            _context.prev = 12;

            if (!(subscriptionAdapter != null && subscriptionAdapter.status() !== SubscriptionAdapterStatus.Closed)) {
              _context.next = 17;
              break;
            }

            // still connected
            if (refreshTimeout) {
              clearTimeoutSafe(refreshTimeout);
            }

            refreshTimeout = setTimeoutSafe(function () {
              return refreshSubscriptionAdapter(url, cursor, context, viewModelName, aggregateIds, false);
            }, REFRESH_TIMEOUT);
            return _context.abrupt("return", Promise.resolve());

          case 17:
            _context.next = 21;
            break;

          case 19:
            _context.prev = 19;
            _context.t1 = _context["catch"](12);

          case 21:
            // disconnected
            try {
              if (subscriptionAdapter != null) {
                adaptersMap["delete"](key);

                if (refreshTimeout) {
                  clearTimeoutSafe(refreshTimeout);
                }

                refreshTimeout = null;
              }
            } catch (err) {}

            return _context.abrupt("return", Promise.resolve());

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 5], [12, 19]]);
  }));

  return function refreshSubscriptionAdapter(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
export var dropSubscribeAdapterPromise = function dropSubscribeAdapterPromise() {
  adaptersMap = new Map();

  if (refreshTimeout) {
    clearTimeoutSafe(refreshTimeout);
  }

  refreshTimeout = null;
};

var connect = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context, url, cursor, aggregateIds, eventCallback, viewModelName, subscribeCallback) {
    var subscriptionKeys, _iterator, _step, _step$value, eventType, aggregateId, key, cachedAdapter, subscriptionAdapter;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            subscriptionKeys = getSubscriptionKeys(context, viewModelName, aggregateIds);

            for (_iterator = _createForOfIteratorHelperLoose(subscriptionKeys); !(_step = _iterator()).done;) {
              _step$value = _step.value, eventType = _step$value.eventType, aggregateId = _step$value.aggregateId;
              addCallback(eventType, aggregateId, eventCallback, subscribeCallback);
            }

            key = buildKey(viewModelName, aggregateIds);
            cachedAdapter = adaptersMap.get(key);

            if (!(cachedAdapter != null && cachedAdapter.status() !== SubscriptionAdapterStatus.Closed)) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return");

          case 6:
            subscriptionAdapter = initSubscriptionAdapter(url, cursor, context, viewModelName, aggregateIds);

            if (!(subscriptionAdapter === null)) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return");

          case 9:
            adaptersMap.set(key, subscriptionAdapter);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function connect(_x7, _x8, _x9, _x10, _x11, _x12, _x13) {
    return _ref3.apply(this, arguments);
  };
}();

var disconnect = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context, aggregateIds, viewModelName, callback) {
    var subscriptionKeys, key, subscriptionAdapter, _iterator2, _step2, _step2$value, eventType, aggregateId;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            subscriptionKeys = getSubscriptionKeys(context, viewModelName, aggregateIds);
            key = buildKey(viewModelName, aggregateIds);
            subscriptionAdapter = adaptersMap.get(key);

            if (!subscriptionAdapter) {
              _context3.next = 6;
              break;
            }

            _context3.next = 6;
            return subscriptionAdapter.close();

          case 6:
            for (_iterator2 = _createForOfIteratorHelperLoose(subscriptionKeys); !(_step2 = _iterator2()).done;) {
              _step2$value = _step2.value, eventType = _step2$value.eventType, aggregateId = _step2$value.aggregateId;
              removeCallback(eventType, aggregateId, callback);
            }

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function disconnect(_x14, _x15, _x16, _x17) {
    return _ref4.apply(this, arguments);
  };
}();

export { connect, disconnect };
//# sourceMappingURL=subscribe.js.map